
































import { Component, Vue, Prop, State } from 'nuxt-property-decorator'
import { IconNext } from '@klook/klook-icons'

@Component({
  components: {
    DesktopActivityCard: () => import('~/components/tour/section-list/recommend-activity-section/card/desktop/index.vue' /* webpackChunkName: 'desktop-recommend-activity-card' */),
    MobileActivityCard: () => import('~/components/tour/section-list/recommend-activity-section/card/mobile/index.vue' /* webpackChunkName: 'mobile-recommend-activity-card' */),
    IconNext
  }
})
export default class RecommendActivityCardWrapper extends Vue {
  @State(state => state.klook.platform) platform!: Data.Platform
  @Prop() item!: any
  @Prop() paramsIndex!: number

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get componentName() {
    return this.isDesktop ? 'DesktopActivityCard' : 'MobileActivityCard'
  }

  getSpm(item: any) {
    const ext = {
      FrontendTree: item?.track_info?.FrontendTree || '',
      order: this.paramsIndex
    }

    return `CategorySeeAll?ext=${encodeURIComponent(JSON.stringify(ext))}`
  }
}
